export default "__VITE_ASSET__DweNpvmh__"